import { render, staticRenderFns } from "./CreateCustomerOrderButton.vue?vue&type=template&id=840e5042&"
import script from "./CreateCustomerOrderButton.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerOrderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports